import { RESET_REQUEST, RESET_SUCCESS, RESET_FAILURE,RESET_ON_SUCCESS } from '../../../Constants/actionTypes';

const initialState = {
  loading: false,
  data: null,
  error: null,
  onSucces: false
};

const resetReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        onSucces: false
      };
    case RESET_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
        onSucces: true
      };
    case RESET_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        onSucces: false
      };
    case RESET_ON_SUCCESS:
      return {
        ...state,
        onSucces: false,
        error:null
      }
    default:
      return state;
  }
};

export default resetReducer;
